import { render, staticRenderFns } from "./InteractionPreviewAds.vue?vue&type=template&id=15efbfc0&scoped=true"
import script from "./InteractionPreviewAds.vue?vue&type=script&lang=js"
export * from "./InteractionPreviewAds.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15efbfc0",
  null
  
)

export default component.exports